import * as React from 'react';
import { styled } from '@mui/system';
import { TextField } from '@mui/material';

export const CommonTextArea = React.memo((props:any) =>{
  const {onChange,value,multiline,rows=3,name="",type="text",placeholder="Please Enter",error = false,
    helperText = "",
    required = false}=props;
  // console.log('given-value',value)
  // const [defaultVal,setDefaultVal] = React.useState('');
  // React.useEffect(() => {
  //   setDefaultVal(value);
  // }, [])
  const onchangeHandler = (e:any) =>{
    if(type === "number"){
      e.target.value = e?.target?.value.replace(/[^0-9]/g, '').slice(0, 2)
    }
    return onChange(e,name)
  }
  return (
    <>
        <TextField
          //id="standard-multiline-flexible"
          fullWidth
          label=""
          multiline={multiline}
          // maxRows={rows}
          rows={rows}
          defaultValue={value}
          //value={value}
          // type={type}
          required={required}
          error={error}
          helperText={error ? helperText : ""}
          placeholder={placeholder}
          className={`common-new-input ${error ? "err-field" : ""} ${multiline ? "multiline" : ""}`}
          // className={`common-new-input ${multiline?"multiline":""}`}
        //   variant="standard"
          name={name}
          onChange={onchangeHandler}
        />
    </>
  );
})
export default CommonTextArea;